import React from "react";

const Admin = (props) => {
  

return  (
    <>
      <div className="menu">
          {/* <ul className='no-bullets'>
            <li className='link-no-decorations'> <Link to="/">Home</Link> </li>
            <li className='link-no-decorations'> <Link to="/mock">Mock User</Link> </li>
            <li className='link-no-decorations'> <Link to="/election">Manage Elections</Link> </li>
          </ul> */}
          <h1 className='h3'>Welcome to the Voting Booth</h1>
          <p>As an admin, you have the ability to add, delete and edit ballots and candidates.<br />
          Please use the menu in the header to navigate to where you need to be.<br /></p>
          <p>With great power comes great responsibilities, if you mess up, please submit a ticket.</p>
      </div>
    </>
  ); 
}

export default Admin;
